export const createEmptyPolicy = () => ({
	general: {
		enabled: true,
		policyName: "Standard Comp-Off Policy",
		policyCode: "COMP-OFF-001",
		activeStatus: true,
		status: "draft",
		offices: [],
		departments: [],
		designations: [],
		employeeTypes: [],
		weeklyOffEligible: true,
		holidayEligible: true,
		overtimeEligible: true,
		minHoursWorked: 4,
		allowCombination: true,
		combineAcrossDays: true,
		combinationWindowDays: 7,
		minCombinedHours: 8,
	},
	calculation: {
		calculationComboOffTypeId: 1,
		roundComboOffTypeId: 1,
		roundHalfDay: true,
		maxCreditPerDay: 1.5,
		maxCreditPerMonth: 4,
	},
});

export const DUMMY_EMPLOYEE_BALANCE = {
	available: 3.5,
	pending: 1,
	used: 2,
	expiringSoon: 0.5,
};

export const DUMMY_EMPLOYEE_REQUESTS = {
	available: [
		{ id: 1, workedDate: "2026-05-10", credit: 1, expiryDate: "2026-08-10", status: "Approved" },
		{ id: 2, workedDate: "2026-05-03", credit: 0.5, expiryDate: "2026-08-03", status: "Approved" },
		{ id: 3, workedDate: "2026-04-28", credit: 1, expiryDate: "2026-07-28", status: "Approved" },
	],
	pending: [
		{ id: 4, workedDate: "2026-05-22", hours: 9, reason: "Project deadline on holiday", status: "Pending" },
	],
	history: [
		{ id: 5, workedDate: "2026-04-15", credit: 1, usedDate: "2026-05-01", status: "Used" },
		{ id: 6, workedDate: "2026-03-20", credit: 0.5, usedDate: "2026-04-10", status: "Used" },
	],
	expiring: [
		{ id: 2, workedDate: "2026-05-03", credit: 0.5, expiryDate: "2026-06-03", daysLeft: 9 },
	],
};
